import { render } from "./DatabaseElementView.vue?vue&type=template&id=7934d28e&scoped=true&ts=true"
import script from "./DatabaseElementView.vue?vue&type=script&lang=ts"
export * from "./DatabaseElementView.vue?vue&type=script&lang=ts"

import "./DatabaseElementView.vue?vue&type=style&index=0&id=7934d28e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7934d28e"]])

export default __exports__